var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import PropTypes from "prop-types";
import Typography from "../Typography";
var clName = function (suffix) {
    if (suffix === void 0) { suffix = ""; }
    var mainClassName = "mex-btn";
    return "".concat(mainClassName).concat(suffix);
};
export var Button = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? "primary" : _c, _d = _a.loading, loading = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "medium" : _e, _f = _a.weak, weak = _f === void 0 ? false : _f, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, onClick = _a.onClick, _g = _a.className, className = _g === void 0 ? "" : _g, children = _a.children, block = _a.block, props = __rest(_a, ["variant", "loading", "size", "weak", "leftIcon", "rightIcon", "onClick", "className", "children", "block"]);
    var classNames = classnames((_b = {},
        _b[clName()] = true,
        _b[clName("--block")] = block,
        _b[clName("--loading")] = loading,
        _b[clName("--".concat(variant))] = true,
        _b[clName("--".concat(size))] = true,
        _b[className] = className,
        _b));
    return (_jsxs("button", __assign({ className: classNames, onClick: onClick }, props, { children: [leftIcon && leftIcon, _jsx("span", __assign({ className: clName("__text") }, { children: _jsx(Typography, __assign({ variant: weak ? "body01Regular" : "body01Semibold", style: { color: "inherit" } }, { children: children })) })), rightIcon && rightIcon] })));
};
Button.propTypes = {
    variant: PropTypes.oneOf(["primary", "secondary", "ghost", "alert", "alert-ghost"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
    loading: PropTypes.bool,
    leftIcon: PropTypes.string || PropTypes.node,
    rightIcon: PropTypes.string || PropTypes.node,
    onClick: PropTypes.func,
    className: PropTypes.string,
    block: PropTypes.bool,
    weak: PropTypes.bool,
    children: PropTypes.string,
};
Button.defaultProps = {
    variant: "primary",
    size: "medium",
};
export default Button;
